'use strict';

import React from 'react';
import ReactGA from "react-ga4";

import {XSquare} from "react-bootstrap-icons";

/**
 * An icon to display in case something has gone wrong.
 * @param props.size Optional size: xs, lg, 6x, ...
 */
const Broken = (props) => {
    ReactGA.gtag('event', 'exception', {
        description: `${props.name}: component broken`,
        fatal: true
    });

    return (
        <XSquare size={props.size ? props.size : "1rem"}
                  title={`Something went wrong with the ${props.name} component.`}
                  className="m-1" />
    );
}

export default Broken;